import {
  type EpocusReview,
  RXDB_EPOCUS_REVIEW_COLLECTION_NAME,
} from "$global-providers/rxdb-provider/collections/epocus-review";
import { useRxData } from "rxdb-hooks";

export const useExamReview = (
  examId: string | undefined,
  reviewerId?: string,
): {
  review: EpocusReview | null;
  draft: EpocusReview | null;
  loading: boolean;
} => {
  const { result, isFetching } = useRxData<EpocusReview>(
    RXDB_EPOCUS_REVIEW_COLLECTION_NAME,
    (collection) =>
      examId
        ? collection.find({
            selector: { examId: { $eq: examId } },
            sort: [{ signedAt: "desc" }],
          })
        : undefined,
  );

  return {
    review: result.find((entry) => entry.signedAt != null) ?? null,
    draft:
      reviewerId === undefined
        ? null
        : (result.find(
            (entry) =>
              entry.signedAt == null && entry.reviewerId === reviewerId,
          ) ?? null),
    loading: isFetching,
  };
};
